import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IReduxState } from "../../../interfaces/IReduxState";

export const CommonFilterSlice = createSlice({
  name: "CommonFilterSlice",
  initialState: {} as IReduxState<any>,
  reducers: {
    commonFilter: (state, _: PayloadAction<any>) => {
      state.isLoading = true;
    },
    successCommonFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureCommonFilter: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    clearCommonFilter: (state) => {
      state.data = {};
    },
  },
});

export const {
  commonFilter,
  failureCommonFilter,
  successCommonFilter,
  clearCommonFilter,
} = CommonFilterSlice.actions;

export default CommonFilterSlice.reducer;
